var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 7.33337C4.16667 7.21137 4.21846 7.09003 4.32102 6.9827C4.41411 6.88614 4.54391 6.80646 4.69816 6.75116C4.8524 6.69587 5.026 6.6668 5.20256 6.66669L14.7976 6.66669C15.1571 6.66669 15.4906 6.78669 15.6792 6.9827C15.7716 7.07946 15.8243 7.18977 15.8323 7.30325C15.8402 7.41672 15.8032 7.52964 15.7248 7.63138L10.9272 12.9649C10.841 13.0756 10.7087 13.1687 10.5449 13.2338C10.3812 13.2989 10.1925 13.3334 10.0001 13.3334C9.80765 13.3334 9.619 13.2989 9.45527 13.2338C9.29153 13.1687 9.15916 13.0756 9.07297 12.9649L4.27544 7.63138C4.20292 7.53805 4.16667 7.43471 4.16667 7.33337Z",
    fill: "#161E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.4de975b0eca46ec08b2799430386a523.svg";
export { ForwardRef as ReactComponent };